import React from "react";
import BottomNavWrapper from "components/shared/wrappers/BottomNavWrapper";
import PhoneWrapper from "components/shared/wrappers/PhoneWrapper";
import {  useParams } from "bcms-react";
import "./styles.css";
/**
 * @function CapturePage
 * @returns {React.Component}
 * @exported true
 * @description Serves as a page component to allow us to route from MABI23 specific pages to ABI22 pages.
 */
export default function CapturePage(props) {
  const {page} = useParams();
  const setPage = page !== undefined ? page : props.page === undefined ? "accountSummary":props.page;
  return (
   <div className="capture-page">
      <BottomNavWrapper page = {setPage}/>
    </div>
  );
}